"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/form/examples/index.ts';
var FormExample = /** @class */ (function () {
    function FormExample() {
        var _this = this;
        this.isSubmitting = false;
        this.handleSubmit = function (e) {
            e.preventDefault();
            _this.isSubmitting = true;
            setTimeout(function () {
                _this.isSubmitting = false;
                mithril_1.default.redraw();
                var target = e.target;
                var inputs = target.elements;
                var values = {};
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    values[input.name] = input.value;
                }
                alert(JSON.stringify(values));
            }, 500);
        };
    }
    FormExample.prototype.view = function () {
        var span = {
            xs: 12,
            sm: 12,
            md: 6
        };
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Form, { gutter: 15, onsubmit: this.handleSubmit }, [
                (0, mithril_1.default)(_1.FormGroup, { span: span }, [
                    (0, mithril_1.default)(_1.FormLabel, { for: 'username' }, 'Username'),
                    (0, mithril_1.default)(_1.Input, {
                        contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.USER }),
                        id: 'username',
                        name: 'username',
                        placeholder: 'Username...'
                    })
                ]),
                (0, mithril_1.default)(_1.FormGroup, { span: span }, [
                    (0, mithril_1.default)(_1.FormLabel, { for: 'password' }, 'Password'),
                    (0, mithril_1.default)(_1.Input, {
                        contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.LOCK }),
                        id: 'password',
                        name: 'password',
                        placeholder: 'Password...'
                    })
                ]),
                (0, mithril_1.default)(_1.FormGroup, { span: span }, [
                    (0, mithril_1.default)(_1.FormLabel, { for: 'selection' }, 'User'),
                    (0, mithril_1.default)(_1.CustomSelect, {
                        options: ['John', 'Jessica', 'Billy bob'],
                        defaultValue: 'Jessica',
                        name: 'users',
                        triggerAttrs: {
                            iconLeft: _1.Icons.USERS,
                            align: 'left',
                            fluid: true
                        }
                    })
                ]),
                (0, mithril_1.default)(_1.FormGroup, { span: span }, [
                    (0, mithril_1.default)(_1.FormLabel, { for: 'occupation' }, 'Occupation'),
                    (0, mithril_1.default)(_1.Input, {
                        contentLeft: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.BRIEFCASE }),
                        id: 'occupation',
                        name: 'occupation',
                        placeholder: 'Occupation...'
                    })
                ]),
                (0, mithril_1.default)(_1.FormGroup, { class: _1.Classes.ALIGN_RIGHT }, [
                    (0, mithril_1.default)(_1.Button, {
                        iconRight: _1.Icons.CHEVRON_RIGHT,
                        type: 'submit',
                        label: 'Submit',
                        intent: 'primary',
                        loading: this.isSubmitting
                    })
                ])
            ])
        ]);
    };
    return FormExample;
}());
exports.FormExample = FormExample;
